import { render } from "./contact-grid.vue?vue&type=template&id=c5287a20"
import script from "./contact-grid.vue?vue&type=script&lang=js"
export * from "./contact-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__